function createManagementAuthGuard({ storage, redirectPath }) {
  return (to, from, next) => {
    if (storage.getItem('accesstoken')) {
      next();
    } else {
      next(redirectPath);
    }
  };
}

function createManagementRouter({ Framework, RouterLibrary, base, routes }) {
  Framework.use(RouterLibrary);

  const originalPush = RouterLibrary.prototype.push;
  RouterLibrary.prototype.push = function push(location) {
    return originalPush.call(this, location).catch((error) => {
      if (error.name !== 'NavigationDuplicated') throw error;
    });
  };

  return new RouterLibrary({
    mode: 'history',
    base,
    routes,
    scrollBehavior() {
      return { x: 0, y: 0 };
    },
  });
}

createManagementRouter.createAuthGuard = createManagementAuthGuard;

module.exports = createManagementRouter;
